import React from "react";
import {
    FacebookShareButton,
    FacebookIcon,
    FacebookMessengerShareButton,
    FacebookMessengerIcon,
    TwitterShareButton,
    TwitterIcon,
    EmailShareButton,
    EmailIcon,
    WhatsappShareButton,
    WhatsappIcon,
} from "react-share";
import { useLanguage } from "../useLanguage";
import styled from "styled-components";

const ContainerBackground = styled.div`
    border-radius: 1em;
    overflow: hidden;
    background: url("/friends.jpg");
    background-size: cover;
    background-position: center;
`;

const Container = styled.div`
    padding: 2em;
    font-size: 1.2em;
    color: white;
    height: 100%;
    width: 100%;
    background: #0008;
`;

const FACEBOOK_APP_ID = "1769181909926311";

type FriendInviteCardProps = {
    registerFriendId: number;
    style?: React.CSSProperties;
};

export function FriendInviteCard(props: FriendInviteCardProps) {
    const language = useLanguage();
    const url = `https://${language("domain")}/?f=${props.registerFriendId * 1244}`;
    const message = language("share-message");
    return (
        <ContainerBackground style={props.style}>
            <Container>
                <div>
                    <h3>{language("share-title")}</h3>
                    <FacebookShareButton url={url}>
                        <FacebookIcon size={40} round={true} />
                    </FacebookShareButton>
                    <FacebookMessengerShareButton appId={FACEBOOK_APP_ID} url={url}>
                        <FacebookMessengerIcon size={40} round={true} />
                    </FacebookMessengerShareButton>
                    <TwitterShareButton url={url} title={message}>
                        <TwitterIcon size={40} round={true} />
                    </TwitterShareButton>
                    <EmailShareButton body={message} url={url}>
                        <EmailIcon size={40} round={true} />
                    </EmailShareButton>
                    <WhatsappShareButton title={message} url={url}>
                        <WhatsappIcon size={40} round={true} />
                    </WhatsappShareButton>
                </div>
            </Container>
        </ContainerBackground>
    );
}
